// extracted by mini-css-extract-plugin
export var statItem = "_ci-1";
export var statsRow = "_ci-0";